import { useEffect } from "react";
import { type RichTextEditorRef } from "mui-tiptap";

interface ContentProps {
    value: string;
    visible: boolean;
    rteRef: React.RefObject<RichTextEditorRef>;
    fontFamilySelectRef: React.RefObject<HTMLDivElement>;
}

export const MesTextEditorContent = (props: ContentProps) => {

    const { 
        value,
		visible,
		rteRef, fontFamilySelectRef
    } = props;

    // 외부 값이 변경되거나 visible 상태가 변경될 때 에디터 내용 동기화
    useEffect(() => {
        const editor = rteRef.current?.editor;
        if (editor && visible) {
            if (editor.getHTML() !== value) {
                editor.commands.setContent(value || '');
            }
        }
    }, [value, visible, rteRef]);

    // 단축키 설정
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Shift + . 은 키보드 레이아웃이나 브라우저에 따라 '>', '.', 'Period' 등으로 인식될 수 있습니다.
            if (e.ctrlKey && e.shiftKey && (e.key === '>' || e.key === '.' || e.code === 'Period')) {
                e.preventDefault();
                
                // mui-tiptap의 Select 컴포넌트는 내부적으로 <button>이 아니라 role="combobox" 또는 role="button"을 가진 <div>를 사용합니다.
                const selectElement = fontFamilySelectRef.current?.querySelector('[role="combobox"], [role="button"]') as HTMLElement;
                
                if (selectElement) {
                    // Material UI의 Select는 단순 click() 보다 mousedown 이벤트에 반응하여 드롭다운을 엽니다.
                    selectElement.dispatchEvent(new MouseEvent('mousedown', { bubbles: true }));
                    selectElement.click();
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [fontFamilySelectRef]);

    return {};
}
